export enum UploadDocumentsFormLabelsEnum {
  TITLE = 'Upload Documents',
}
